import { type MessageType } from "../../common/components/Messages/Message";

import type { TranslationModel } from "~/common/TranslationModel";

export interface MessageData {
  id: number;
  severity: MessageType;
  message: TranslationModel;
}

export type GlobalMessageTextType = "raw" | "translation";

export type GlobalMessagesStore = MessageData[];

export const globalMessagesInitialState: GlobalMessagesStore = [];
